export const getSecondsElapsed = timeStarted => {
  const nowTime = Date.now();
  const secondsElapsed = nowTime - timeStarted.getTime();
  return Math.floor(secondsElapsed / 1000);
};